<template>
  <div
    class="d-flex top-bar"
    @click="$store.dispatch('setRoomPublic', roomLocked)"
  >
    <div v-if="isOwner && status === 'joined'" class="lock-room">
      <img
        :src="require('../../assets/img/locked-icon.svg')"
        style="width: 24px; height: 24px; margin-right: 16px"
      />
      <span v-if="roomLocked" class="label">Unlock room</span>
      <span v-else class="label">Lock room</span>
    </div>

    <div v-if="status === 'joined'" class="participant-number flex-1 text-center">
      <img
        :src="require('../../assets/img/meeting-triple-icon.svg')"
        style="width: 22px; height: 22px"
      />
      <span style="margin-left: 16px"
        >{{ participantCount }} of {{ meetingCapacity }}</span
      >
    </div>

    <div class="show-settings">
      <span class="label">Settings</span>
      <img
        :src="require('../../assets/img/settings.svg')"
        style="width: 24px; height: 24px; margin-left: 16px"
        @click="showSettingsModal()"
      />
    </div>
  </div>

  <!--  <div
        v-if="localParticipant && localParticipant.owner">
      <div class="lock-room">
        <img
            :src="require('../assets/img/locked-icon.svg')"
            style="width: 24px; height: 24px"
        />
        <h1 id="lock-title" style="margin-left: 16px">Lock room</h1>
      </div>
      <div class="participants-count">
        <img
            :src="require('../assets/img/meeting-triple-icon.svg')"
            style="width: 22px; height: 22px"
        />
        <h1 id="count-title">{{ meetingParticipants.length }} of 100</h1>
      </div>
      <div class="settings">
        <h1 id="title">Settings</h1>
        <img
            :src="require('../assets/img/settings.svg')"
            style="width: 24px; height: 24px; margin-left: 16px"
            @click="showSettingsModal()"
        />
      </div>
    </div>-->
</template>

<script>
export default {
  name: "MeetingTopBar",
  computed: {
    isOwner() {
      return this.$store.state.meeting.isOwner;
    },
    status() {
      return this.$store.state.meeting.status;
    },
    meeting() {
      return this.$store.state.meeting.meeting;
    },
    roomLocked() {
      return !this.meeting?.isPublic;
    },
    participantCount() {
      return this.$store.state.meeting.participants.length;
    },
    meetingCapacity() {
      return this.meeting?.capacity;
    },
  },
  methods: {
    showSettingsModal() {
      this.$store.commit("showModal", "settings_modal");
    },
  },
};
</script>

<style scoped lang="scss">
.top-bar {
  padding: 0px 1rem;
  justify-content: flex-end;

  span {
    font-family: sans-serif;
    font-family: sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
}
.lock-room,
.show-settings {
  cursor: pointer;
  display: flex;

  .label {
    display: none;
  }

  @media screen and (min-width: 768px) {
    .label {
      display: block;
    }
  }
}

.participant-number {
  display: flex;
  justify-content: center;
}
</style>
